"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _config = require("./config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaTooltip = _react["default"].forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className,
      content = props.content,
      isShowing = props.isShowing,
      other = props.other,
      position = props.position,
      width = props.width,
      showOnHover = props.showOnHover,
      onShow = props.onShow,
      onHide = props.onHide,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart;
  var eventProps = {
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart
  };
  var isControlled = typeof isShowing === 'boolean';

  var hasIconAction = _react["default"].Children.toArray(children).reduce(function (hasIA, el) {
    return el.type.displayName === 'LunaIconAction' || hasIA;
  }, false);

  var getTargetClass = function getTargetClass() {
    var _classnames;

    return (0, _classnames3["default"])(_config.classes.target, (_classnames = {}, _defineProperty(_classnames, _config.classes.hasIconAction, hasIconAction), _defineProperty(_classnames, _config.classes.showOnHover, showOnHover && !isControlled), _defineProperty(_classnames, _config.classes.manualShow, isShowing), _defineProperty(_classnames, _config.classes.manualHide, isShowing === false), _classnames), className);
  };

  var getTooltipClass = function getTooltipClass() {
    var _classnames2;

    return (0, _classnames3["default"])(_config.classes.tooltip, (_classnames2 = {}, _defineProperty(_classnames2, _config.classes.positions.bottomMiddle, position === _config.TooltipPositions.BottomMiddle), _defineProperty(_classnames2, _config.classes.positions.leftBottom, position === _config.TooltipPositions.LeftBottom), _defineProperty(_classnames2, _config.classes.positions.leftMiddle, position === _config.TooltipPositions.LeftMiddle), _defineProperty(_classnames2, _config.classes.positions.leftTop, position === _config.TooltipPositions.LeftTop), _defineProperty(_classnames2, _config.classes.positions.rightBottom, position === _config.TooltipPositions.RightBottom), _defineProperty(_classnames2, _config.classes.positions.rightMiddle, position === _config.TooltipPositions.RightMiddle), _defineProperty(_classnames2, _config.classes.positions.rightTop, position === _config.TooltipPositions.RightTop), _defineProperty(_classnames2, _config.classes.positions.topMiddle, position === _config.TooltipPositions.TopMiddle), _defineProperty(_classnames2, _config.classes.positions.topMiddle, position === _config.TooltipPositions.TopMiddle), _defineProperty(_classnames2, _config.classes.widths.medium, width === _config.TooltipWidths.medium), _classnames2));
  };

  var handleMouseEnter = function handleMouseEnter(event) {
    if (onMouseEnter) {
      onMouseEnter(event);
    }

    if (showOnHover) {
      if (onShow) {
        onShow();
      }
    }
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    if (showOnHover) {
      if (onHide) {
        onHide();
      }
    }
  };

  return _react["default"].createElement("div", _extends({}, other, eventProps, {
    className: getTargetClass(),
    ref: ref,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }), children, _react["default"].createElement("div", {
    className: getTooltipClass()
  }, content));
});

LunaTooltip.displayName = 'LunaTooltip';
LunaTooltip.propTypes = {
  className: _propTypes["default"].string,
  position: _propTypes["default"].oneOf(Object.values(_config.TooltipPositions)),
  width: _propTypes["default"].oneOf(Object.values(_config.TooltipWidths)),
  showOnHover: _propTypes["default"].bool,
  isShowing: _propTypes["default"].bool,
  other: _propTypes["default"].object,
  children: _propTypes["default"].object,
  content: _propTypes["default"].any,
  onShow: _propTypes["default"].func,
  onHide: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func
};
LunaTooltip.defaultProps = {
  position: _config.TooltipPositions.TopMiddle,
  showOnHover: false
};
var _default = LunaTooltip;
exports["default"] = _default;
